export const ACCOUNT_TRANSLATION_NAMESPACE = "account";

export const ACCOUNT_LAYOUT_TK = "ACCOUNT_LAYOUT_TK";
export const ACCOUNT_PREFERENCE_VIEW_TK = "ACCOUNT_PREFERENCE_VIEW_TK";
